var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shadow-sm"},[_c('Nav'),_c('weekly-agenda',{key:_vm.employee_id,staticClass:"bg-white p-2",attrs:{"employee_id":_vm.employee_id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }